/**
 * 数组转对象
 * @param {*} arr
 * @param {*} key_property
 * @param {*} value_property
 * @returns
 */
export function arrToObj(arr = [], key_property, value_property) {
  return arr.reduce((pre, next) => {
    pre[next[key_property]] = next[value_property]
    return pre
  }, {})
}

export function getAliasName(treeNodeId, treeNodeMap, nodeNameArr = []) {
  const node = treeNodeMap[treeNodeId];
  nodeNameArr.push(node ? node.name : "");
  if (node.level === 1) {
    return nodeNameArr.reverse().join("/");
  }
  if (!treeNodeId || !treeNodeMap) {
    return "";
  }
  return getAliasName(node.pid, treeNodeMap, nodeNameArr);
};

/**
 * 复制对象属性
 * @param { Array } propertyArr 
 * @param { Object } target 
 * @param { Object } source 
 */
export function copyProperty(propertyArr = [], target, source) {
  for (const property of propertyArr) {
    if (source[property] !== undefined) {
      target[property] = source[property]
    }
  }
}

const formatter_time = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

  const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

  return `${[year, month, day].join('-')} ${[hour, minutes, seconds].join(':')}`

}

export default {
  formatter_time
};

export function now() {
  return formatter_time(new Date())
}

/**
 * 匹配规则 以中英文_开头 内容长度为4-20位中英文_数字
 * @param {*} str 
 * @returns 
 */
export function checkNameRule(str) {
  return /(?<=[a-zA-z\u4e00-\u9fa5_])[a-zA-z\u4e00-\u9fa5_0-9]+/.test(str);
}
